const isValid = (name) => {
    var regex = /^(?!.* {2})(?=\S)(?=.*\S$)[a-zA-ZÀ-ÿ\s]*$/;
    return regex.test(String(name).toLowerCase());
}

export const nameValidator = {
    isValid
}